module.exports = __webpack_public_path__ + "img/HVU_Logo.4f7e5984.svg";